<style scoped lang="scss">
@import "../../style/color";
@import "../../style/mixin";

.detail {
  @include content;
  margin-bottom: 30px;
  margin-left: 0;
  margin-right: 0;
  background: #fff;
  .crumbs {
    margin: 20px 0 15px;
    color: $c_6DB;

    .breadrumb-item {
      margin-right: 10px;
    }

    .breadrumb-item.active {
      color: $c_6DB;
    }
    a {
      margin-right: 5px;
      color: $c_6DB;
      text-decoration: underline;
      font-family: "EperFontBold";
      font-size: 14px;
    }
    .router {
      margin-right: 5px;
      font-family: "EperFontBold";
      font-size: 14px;
    }
    .last {
      font-family: "EperFontLight";
      font-size: 14px;

      color: $c_6DB;
    }
  }

  .product-introduction {
    margin-bottom: 65px;
    .product-pic {
      width: 540px;

      .enlarge {
        position: relative;
        width: 410px;
        height: 410px;

        // 视频样式start
        .play {
          width: 60px;
          height: 60px;
          object-fit: contain;
          position: absolute;
          bottom: 40px;
          left: 50%;
          transform: translateX(-50%);
          // top: 50%;
          // transform: translate(-50%, -50%);
          z-index: 88;
          cursor: pointer;
        }
        .cancel {
          width: 30px;
          height: 30px;
          object-fit: contain;
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 110;
          cursor: pointer;
        }

        .goods-video {
          position: absolute;
          top: 0px;
          left: 0px;
          z-index: 100;
          // width: 100%;
          // height: 100%;
          object-fit: contain;
          background-color: #000;
        }

        .goods-video:focus {
          outline: none;
        }
        // 视频样式end
        .low-price {
          position: absolute;
          left: 0;
          top: 0;
          height: 110px;
          z-index: 77;
          .ch_img {
            width: 108px;
            height: 110px;
          }
        }
        .discount {
          position: absolute;
          right: 10px;
          bottom: 50px;
          height: 46px;
          z-index: 77;
          .discount_img {
            width: 90px;
            height: 46px;
          }
        }
        .quality {
          position: absolute;
          width: 245px;
          height: 35px;
          bottom: 0;
          left: 50%;
          margin-left: -122px;
          z-index: 77;
          .quality_img {
            width: 245px;
            height: auto;
          }
        }
        .limittime {
          position: absolute;
          left: 0;
          bottom: 50px;
          height: 30px;
          z-index: 77;
          .limittime_img {
            width: 112px;
            height: 30px;
          }
        }
        .exclusive {
          position: absolute;
          right: 0;
          bottom: 43px;
          height: 62px;
          z-index: 76;
          .exclusive_img {
            width: 134px;
            height: 62px;
          }
        }
        .biaoshi {
          // position: absolute;
          // top: 0;
          // left: 10px;
          padding: 5px;
          box-sizing: border-box;
          z-index: 77;
          .bsSize {
            // width: 150px;
            // height: 70px;
            width: 140px;
            height: 46px;
          }
        }
        .icon {
          position: absolute;
          top: 0;
          right: 0;
          z-index: 77;
          .img {
            float: right;
            margin: 6px 6px 0 0;
            width: 43px;
            height: 43px;
          }
        }
        .img {
          width: 410px;
          height: 410px;
        }
      }

      .all-pictrue {
        margin-left: 27px;
        width: 70px;
        .up,
        .down {
          width: 100%;
          height: 40px;
          text-align: center;
          cursor: pointer;
        }
        .up {
          &-arrow {
            @include arrowTop(#333);
            display: block;
            margin-left: 32px;
            margin-top: 14px;
          }
        }
        .down {
          &-arrow {
            @include arrowAfterTop(#333);
            display: block;
            margin-left: 32px;
            margin-top: 14px;
          }
        }

        .scroll-wrap {
          width: 70px;
          padding: 5px 0;
          box-sizing: border-box;
          position: relative;
          z-index: 0;
          overflow: hidden;
        }
        .item {
          position: absolute;
          left: 0;
          top: 0;
          right: 0;
          transition: top 0.5s;
          &-li {
            width: 70px;
            height: 70px;
            box-sizing: border-box;
            padding: 0;
            margin-bottom: 10px;
            display: block;
            cursor: pointer;
            .img {
              width: 70px;
              height: 70px;
            }
          }
        }
      }
    }

    .product-info {
      width: 510px;

      .title {
        font-size: 22px;
        position: relative;
        height: 93px;
        .product-BrandName{
          width: 425px;
          font-size: 22px;
          font-weight: bold;
          color: #000;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }
        .product-name {
          width: 425px;
          font-weight: bold;
          position: absolute;
          left: 0;
          top: -3px;
        }
        .product-name.top33{
          top: 33px;
        }
        .collect {
          width: 36px;
          text-align: center;
          cursor: pointer;
          & > i {
            color: $c_6DB;
          }
          .img {
            width: 36px;
            height: 31px;
          }
        }
      }

      .tip {
        color: $c_ec1;
        //margin: 15px 0 10px;
        font-weight: bold;
        line-height: 28px;
        font-size: 14px;
        font-family: "EperFontLight" !important;
      }
      .tip.green{
        color: $c_6DB;
        // margin: 15px 0 10px;
        font-weight: bold;
        line-height: 28px;
      }
      .disriptions {
        font-size: $font_base;
        line-height: 22px;
        font-family: "EperFontLight";
        span{
          font-family: "EperFontLight" !important;
        }
      }

      .product-price {
        margin-top: 15px;
        overflow: hidden;
        .product-item-cart-num {
          width: 130px;
          float: left;
          margin-left: 66px;
          margin-top: 9px;
          display: flex;
          .reduce,
          .plus {
            display: inline-block;
            width: 22px;
            height: 22px;
            border-radius: 50%;
            background: $c_6DB;
            color: $c_fff;
            text-align: center;
            font-size: 20px;
            cursor: pointer;
            user-select: none;
          }
          .reduce {
            line-height: 21px;
          }
          .grayBack {
            background: #cccccc;
          }
          .plus {
            line-height: 24px;
          }
          .cart-allnum {
            background: none;
            width: 60px;
            height: 26px;
            line-height: 28px;
            text-align: center;
            color: $c_6DB;
            font-size: 20px;
            font-weight: normal;
            vertical-align: middle;
            display: inline-block;
            &.cart-allnum-noadd {
              margin-left: 27px;
            }
          }
        }
        .price {
          font-size: $font_llg26;
          color: $c_ec1;
          font-weight: bold;
          font-size: 28px;
          // margin-right: 15px;
        }
        .red {
          color: $c_ec1;
        }
        .green {
          color: $c_6DB;
        }
        .origin {
          color: $c_999;
          // font-size: 18px;
          font-size: 14px;
          text-decoration: line-through;
        }
      }

      .add-cart {
        margin-top: 15px;
        clear: both;
        .btn {
          padding: 0 50px;
          background: $c_fff;
          border-radius: 20px;
          text-align: center;
          line-height: 36px;
          color: $c_6DB;
          border: 1px solid $c_6DB;
          // font-weight: bold;
          font-size: 18px;
        }

        .btn:first-child {
          margin-right: 40px;
        }

        .btn:hover {
          background: $c_6DB;
          color: $c_fff;
        }
        .notice {
          border: 1px solid $c_221;
          background: $c_fff;
          color: $c_221;
        }
        .notice:hover {
          border: 1px solid $c_221;
          background: $c_221 !important;
          color: $c_fff;
        }
      }
    }
  }
}
.category-product >>> .subtitle-title {
  height: 45px;
}
.category-product {
  overflow: -hidden;

  /deep/ .pruduct .public .public-ul {
    border: none;
    padding: 0;

    .public-ul-li {
      width: 202px;
      height: 414px;
      cursor: pointer;
      .public-ul-li-pictrue {
        width: 202px;
        height: 202px;

        .img {
          width: 202px;
          height: 202px;
        }

        .icon {
          .img {
            width: 27px;
            height: 27px;
          }
        }
      }
    }
    .public-ul-li:nth-child(4n) {
      margin-right: 10px;
    }

    .public-ul-li:nth-child(5) {
      // margin-right: 0px;
    }

    .pruduct-discription {
      padding: 10px;

      .pruduct-discription-prompt {
        line-height: 30px;
        height: 24px;
      }

      &-all {
        .shopping-cart {
          // .img {
          //   width: 32px;
          //   height: 31px;
          // }
        }
      }
    }
  }

  &-ad {
    margin-top: 10px;
    width: 202px;
  }
}
.detail_img >>> img {
  max-width: 1050px;
  display: block;
}

.discriptions {
  margin-top: 60px;
}
>>> .card-carousel--overflow-container {
  overflow: inherit;
}
>>> .subtitle-title {
  z-index: 1;
}
.activity_back {
  position: absolute;
    left: 0;
    top: 41px;
    z-index: -10;
    width: 100%;
    display: flex;
    justify-content: center;
}

.activity_back img {
  width: 1915px;
}
.no_ddeliver {
  width: 100%;
  height: 46px;
  position: absolute;
  left: 0;
  bottom: 0;
  font-size: 16px;
  font-family: "EperFontBold";
  color: #fff;
  z-index: 1;
  display: -webkit-flex;
  justify-content: center; /*水平居中*/
  align-items: center; /*垂直居中*/
  background: rgba($color: #000000, $alpha: 0.2);
  .no_deliver_msg {
    text-align: center;
    width: 100%;
    padding: 0 10px;
    box-sizing: border-box;
    line-height: 16px;
  }
}
.newbox {
  width: auto;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  background: cornflowerblue;
}
.low-pricet {
  // position: absolute;
  // left: 0;
  // top: 0;
  z-index: 77;
  .ch_img {
    width: 54px;
    height: 55px;
  }
}

.icon_js {
  // position: absolute;
  // left: 0px;
  // top: 72px;
  z-index: 77;
}
.icon_js .js_img {
  width: 33px;
}
.content_active{
  display: flex;
  justify-content: center;

}
.activity_left{
  overflow: hidden;
  background-size: 100% auto;
  z-index: -100;
  position: relative;
  img{
    display: block;
  }
}
.activity_right{
  overflow: hidden;
  img{
    display: block;
  }
  background-size: 100% auto;
}
</style>
<template>
  <div>
    <Header :cartPros="cartPros" ref="headerRef" />
    <header-nav :showType="true" :showPerson="true" />
    <type-nav />
    <!-- 顶部活动 -->
    <div class="activity_back" v-if="GetPromBackGround">
      <img  :src="GetPromBackGround.TopPic" alt="">
    </div>
    <div class="content_active">
      <!-- 左侧活动 -->
      <div class="activity_left"  v-if="GetPromBackGround" :style="{'height':Active_Height+30+'px'}">
          <img v-for="(item,index) in imageNum" :key="index" :src="GetPromBackGround.LeftPic" alt="" />
      </div>
      <div class="detail" ref="ref1" >
        <p class="crumbs">
          <span
            v-for="(item, idx) in catas"
            :key="idx"
            class="breadrumb-item"
            :class="{ active: idx > 0 && idx < catas.length - 1 }"
          >
            <template v-if="idx < catas.length - 1">
              <template v-if="idx > 0">
                <router-link
                  :to="{
                    path: '/category',
                    query: {
                      ProductCataID: item.ProductCataID,
                      isType: true,
                      isFromType: true,
                      isShowSelect: 1,
                    },
                  }"
                  >{{ item.ProductCataName }}</router-link
                >
              </template>
              <template v-else
                ><span class="router">{{
                  item.ProductCataName
                }}</span></template
              >
              <span
                v-for="(k, sidx) in idx + 2"
                :key="sidx"
                style="font-size: 12px"
                >></span
              >
            </template>
            <template v-else>
              <span class="last">{{ item.ProductCataName }}</span>
            </template>
          </span>
        </p>
        <div class="product-introduction clearfix">
          <div class="product-pic fl clearfix">
            <div class="enlarge fl">
              <!-- 视频展示 -->
              <img
                v-if="!showVideo && videoSrc"
                @click="play"
                class="play"
                src="../../assets/icon/btn-play.png"
                alt=""
              />
              <img
                v-if="showVideo && videoSrc"
                @click="cancel"
                class="cancel"
                src="../../assets/icon/btn-cancel.png"
                alt=""
              />
              <video
                ref="video"
                v-if="showVideo && videoSrc"
                controlslist="nodownload"
                disablePictureInPicture="true"
                controls="controls"
                width="410"
                height="410"
                class="goods-video"
                :src="videoSrc"
              ></video>

              <div
                class="discount"
                v-if="
                  isShowDiscount(productDetail.DiscountRate) &&
                  [
                    5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 65, 70, 75, 80,
                    85, 90, 95,
                  ].indexOf(productDetail.DiscountRate) > -1
                "
              >
                <img
                  :src="
                    require('../../assets/icon/product-icon/discount_' +
                      (100 - productDetail.DiscountRate) +
                      '.png')
                  "
                  class="discount_img"
                  :title="$t('productList.discount')"
                  v-if="productDetail.DiscountRate > 0"
                />
              </div>
              <div class="quality" v-if="productDetail.isHighQuailty">
                <img
                  src="../../assets/icon/product-icon/eper_quality_zh.png"
                  class="quality_img"
                  :title="$t('productList.quality')"
                  v-if="lang == 1"
                />
                <img
                  src="../../assets/icon/product-icon/eper_quality_en.png"
                  class="quality_img"
                  :title="$t('productList.quality')"
                  v-else
                />
              </div>
              <div
                class="limittime"
                v-if="
                  productDetail.isLimitTime == true &&
                  [
                    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17,
                    18, 19, 20, 21, 22, 23, 24,
                  ].indexOf(productDetail.LimitTime) > -1
                "
              >
                <img
                  :src="
                    require('../../assets/icon/product-icon/time_' +
                      productDetail.LimitTime +
                      '.png')
                  "
                  :title="$t('productList.limittime')"
                  class="limittime_img"
                />
              </div>
              <div class="exclusive" v-if="productDetail.isExclusive == true">
                <img
                  src="../../assets/icon/product-icon/exclusive_zh.png"
                  class="exclusive_img"
                  :title="$t('productList.exclusive')"
                  v-if="lang == 1"
                />
                <img
                  src="../../assets/icon/product-icon/exclusive_en.png"
                  class="exclusive_img"
                  :title="$t('productList.exclusive')"
                  v-else
                />
              </div>
              <div class="no_ddeliver" v-if="productDetail.NoDeliveryTip">
              <span class="no_deliver_msg">{{
                productDetail.NoDeliveryTip
              }}</span>
            </div>
              <div class="icon">
                <img
                  src="../../assets/icon/product-icon/icon_green_vmdpi.png"
                  class="img"
                  :title="$t('productList.vegetarian')"
                  v-if="productDetail.isvegetarian"
                />
                <img
                  src="../../assets/icon/product-icon/icon_green_gmdpi.png"
                  class="img"
                  :title="$t('productList.glutenFree')"
                  v-if="productDetail.isGlutenFree"
                />
                <img
                  src="../../assets/icon/product-icon/icon_green_smdpi.png"
                  class="img"
                  :title="$t('productList.sugerFree')"
                  v-if="productDetail.isSugerFree"
                />
                <img
                  src="../../assets/icon/product-icon/icon_green_biomdpi.png"
                  class="img"
                  :title="lang == 1 ? '' : $t('productList.organic')"
                  v-if="productDetail.isOrganic"
                />
                <img
                  src="../../assets/icon/product-icon/icon_green_hmdpi.png"
                  class="img"
                  :title="$t('productList.muslim')"
                  v-if="productDetail.isMuslim"
                />
                <img
                  src="../../assets/icon/product-icon/icon_tem_4.png"
                  class="img"
                  :title="$t('productList.temperaAttr')"
                  v-if="productDetail.isTemperaAttr"
                />
                <img
                  src="../../assets/icon/product-icon/icon_tem_18.png"
                  class="img"
                  :title="$t('productList.frozen')"
                  v-if="productDetail.isFrozen"
                />
                <img
                  src="../../assets/icon/product-icon/icon_isInstable.png"
                  class="img"
                  :title="$t('productList.instable')"
                  v-if="productDetail.isInstable"
                />
                <img
                  src="../../assets/icon/product-icon/icon_delivery_thirdmdpi.png"
                  class="img"
                  :title="$t('productList.thirdDistribution')"
                  v-if="productDetail.isThirdDistribution"
                />
              </div>
              <!-- ===================================================== -->
              <div class="newbox">
                <div class="biaoshi">
                  <img
                    v-if="productDetail.isEperSelects"
                    class="bsSize"
                    src="../../assets/icon/product-icon/a_1.png"
                    alt=""
                  />
                  <img
                    class="bsSize"
                    v-if="productDetail.isEperFarm"
                    src="../../assets/icon/product-icon/a_2.png"
                    alt=""
                  />

                  <img
                    class="bsSize"
                    v-if="productDetail.isEperKitchen"
                    src="../../assets/icon/product-icon/a_3.png"
                    alt=""
                  />
                </div>

                <div class="low-pricet" v-if="productDetail.isLowPrice == true">
                  <img
                    src="../../assets/icon/product-icon/icon_ch_en1.png"
                    class="ch_img"
                    :title="$t('productList.lowerPrice')"
                    v-if="lang == 1"
                  />
                  <img
                    src="../../assets/icon/product-icon/icon_ch_en1.png"
                    class="ch_img"
                    :title="$t('productList.lowerPrice')"
                    v-else
                  />
                </div>
                <div class="icon_js" v-if="productDetail.isHB">
                  <img
                    src="../../assets/icon/product-icon/jishi_ch.png"
                    class="js_img"
                    :title="$t('productList.quality')"
                    v-if="lang == 1"
                  />
                  <img
                    src="../../assets/icon/product-icon/jishi_en.png"
                    class="js_img"
                    :title="$t('productList.quality')"
                    v-else-if="lang == 2"
                  />
                  <img
                    src="../../assets/icon/product-icon/jishi_fr.png"
                    class="js_img"
                    :title="$t('productList.quality')"
                    v-else
                  />
                </div>
              </div>

              <!-- ===================================================== -->

              <mirror
                :width="width"
                :piclist="picLargelist"
                :picSmallList="piclist"
                :curThumbIndex="curThumbIndex"
              />
            </div>

            <div class="all-pictrue fl">
              <VCarousel :len="piclist.length">
                <div class="scroll-wrap" :style="'height:'+ (80*piclist.length) +'px;'"  >
                  <ul class="item clearfix scroll-content" ref="ulRef">
                    <li
                      class="item-li"
                      v-for="(img, idx) in piclist"
                      :key="idx"
                      @click.stop="selectPic(idx)"
                    >
                      <img :src="img" class="img" />
                    </li>
                  </ul>
                </div>
              </VCarousel>
            </div>
          </div>
          <div class="product-info fl">
            <div class="title clearfix">
              <p class="product-BrandName">{{ productDetail.BrandName }}</p>
              <p class="product-name inlineBlock" :class="productDetail.BrandName? 'top33':''">
                {{ productDetail.ProductName | fitlterProductName }}
              </p>
              <div
                class="collect fr"
                @click="collect(productDetail.ProductID)"
                v-if="!isCollect"
              >
                <img src="../../assets/icon/un_collect.png" class="img" />
                <!-- <Icon type="ios-heart-outline" size="36"></Icon> -->
              </div>
              <div
                class="collect fr"
                @click="delCollect(productDetail.ProductID)"
                v-else
              >
                <img src="../../assets/icon/collect.png" class="img" />
                <!-- <Icon type="ios-heart" size="36"></Icon> -->
              </div>
            </div>
            <p class="tip">{{ productDetail.Subtitle }}</p>
            <p class="tip green">{{ productDetail.Instro }}</p>
            <p class="disriptions">
              {{ $t("proDetail.proCode") }}: {{ productDetail.ProductCode }}
            </p>
            <!-- <p class="disriptions">Brand: {{productDetail.BrandName}}</p> -->
            <p class="disriptions" v-if="productDetail.PCountryName">
              {{ $t("productList.chandi2") }}: {{ productDetail.PCountryName }}
            </p>
            <p class="disriptions" v-if="productDetail.ProArea">
              {{ productDetail.PCountryName ? $t("productList.chandi1") : $t("productList.chandi") }}: {{ productDetail.ProArea }}
            </p>
            <p
              class="disriptions"
              v-if="productDetail.StandardPrice && IsHideDelivery"
            >
              {{ $t("proDetail.kgPrice") }}:{{ productDetail.StandardPrice }}
            </p>
            <p class="disriptions">
              {{ $t("proDetail.packSpec") }}: {{ productDetail.PackSpec }}
            </p>
            <p class="disriptions">
              <span
                style="fontfamily: EperFontLight"
                v-if="productDetail.TemperaAttr == 1"
                >{{ $t("proDetail.henwen") }}</span
              >
              <span
                style="fontfamily: EperFontLight"
                v-if="productDetail.TemperaAttr == 2"
                >{{ $t("proDetail.lengcang") }}</span
              >
              <span
                style="fontfamily: EperFontLight"
                v-if="productDetail.TemperaAttr == 3"
                >{{ $t("proDetail.lengdong") }}</span
              >
              {{ $t("proDetail.shelfLife") }}&nbsp;{{ productDetail.ShelfLifeNum }}
              {{productDetail.ShelfLifeType == "D" ? $t('proDetail.days') : productDetail.ShelfLifeType == "Y" ? $t("proDetail.year1") : productDetail.ShelfLifeType == "M" ? $t("proDetail.month1") : ""}}
            </p>
            <!-- <p class="disriptions">{{$t('proDetail.getPoints')}}: {{productDetail.Integral}}</p> -->
            <div class="product-price">
              <!-- <span class="pirce">￥{{productDetail.Price}}</span>
            <span class="origin" v-if="productDetail.MarkPrice > 0">￥{{productDetail.MarkPrice}}</span>-->
              <div class="fl">
                <span
                  :class="[
                    'price',
                    productDetail.ProType
                      ? 'red'
                      : Number(productDetail.MarkPrice) >
                        Number(productDetail.Price)
                      ? 'red'
                      : 'green',
                  ]"
                  >￥{{ productDetail.Price | toFix }}</span
                >
                <span
                  class="origin"
                  v-if="
                    Number(productDetail.MarkPrice) >
                    Number(productDetail.Price)
                  "
                  >￥{{ productDetail.MarkPrice | toFix }}</span
                >
              </div>
              <!-- <div class="product-item-cart-num fl" v-if="productDetail.isCanBuy">
                <span
                  class="reduce"
                  :class="goodsNum == 1 ? 'grayBack' : ''"
                  @click="changeCartNum('min')"
                  >-</span
                >
                <input
                  type="text"
                  class="cart-allnum"
                  v-model="goodsNum"
                  onkeyup="this.value=this.value.replace(/\D/g,'')"
                  onafterpaste="this.value=this.value.replace(/\D/g,'')"
                  @input="inputGoodsNum()"
                />
                <span
                  class="plus"
                  :class="goodsNum == 50 ? 'grayBack' : ''"
                  @click="changeCartNum('plu')"
                  >+</span
                >
              </div> -->
            </div>
            <div class="add-cart">
              <button
                class="btn"
                @click="ShowPopup(productDetail)"
                v-if="productDetail.isCanBuy"
              >
                {{ $t("proDetail.addCart") }}
              </button>
              <button
                class="btn notice"
                @click="arrivalRemind(productDetail.ProductID)"
                v-else
              >
                {{ $t("proDetail.restock") }}
              </button>
            </div>
          </div>
        </div>
        <div class="category-product" v-if="tjlist && tjlist.length > 0">
          <sub-title :title="$t('proDetail.rProduct')" />
          <HCarousel
            :len="tjlist.length"
            :paginationFactor="212"
            :windowSize="5"
          >
            <eper-product-list
              :productList="tjlist"
              :fromProductDetail="true"
              :len="tjlist.length"
              :liw="212"
              :IsPopup="true"
            />
          </HCarousel>
        </div>
        <div class="discriptions">
          <sub-title :title="$t('proDetail.dProduct')" />
          <div v-html="productDetail.Bewrite" class="detail_img">
            {{ productDetail.Bewrite }}
          </div>
        </div>
      </div>
      <!-- 右侧活动 -->
      <div class="activity_right" v-if="GetPromBackGround" :style="{'height':Active_Height+30+'px'}">
          <img v-for="(item,index) in imageNum" :key="index" :src="GetPromBackGround.RightPic" alt="" />
      </div>
    </div>
    <Footer />
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>

<script>
import mixin from "../../mixin";
import filter from "../../plugins/filters";
import mirror from "../../components/public/mirror";
import HCarousel from "../../components/public/hCarousel";
import VCarousel from "../../components/public/vCarousel";
const EperProductList = () => import("@/components/productList");

export default {
  name: "productDetail",
  mixins: [mixin],
  components: {
    EperProductList,
    mirror,
    HCarousel,
    VCarousel,
  },
  data() {
    return {
      lang: 1,
      spinShow: false,
      isCollect: false,
      curThumbIndex: 0,
      activeIndex: 0,
      iSpeed: -1,
      width: 410,
      ProductCataID: "",
      catas: [],
      productDetail: {},
      piclist: [],
      imgindex: 0,
      tjlist: [],
      cartPros: {},
      goodsNum: 1,
      picLargelist: [],
      token: filter.readData("userInfo")
        ? filter.readData("userInfo").Token
        : "",
      IsHideDelivery: filter.readData("cityInfo")
        ? filter.readData("cityInfo").IsHideDelivery
        : "",
      videoSrc: "",
      showVideo: false,
      Active_Height:'',
      imageNum:1
    };
  },
  computed:{
    GetPromBackGround(){
      return JSON.parse(localStorage.getItem("promBackGround")) ? JSON.parse(localStorage.getItem("promBackGround")) : null;
    }
  },
  watch: {
    $route: {
      handler(val, oldval) {
        this.curThumbIndex = 0;
        this.$refs.headerRef.setSearchText();
        this.ProductCataID = this.$route.query.ProductCataID;
        this.getDetail(this.$route.query.id || this.$route.query.ProductID);
        this.GetUpCata();
      },
      deep: true,
    },
  },
  created() {
    this.lang = localStorage.getItem("lang");
    this.ProductCataID = this.$route.query.ProductCataID;
    this.getDetail(this.$route.query.id || this.$route.query.ProductID);
    this.editMeta();
    this.GetUpCata();
  },
  filters: {
    fitlterProductName(ProductName) {
      let lang = localStorage.getItem("lang");
      let productName = "";
      if (lang && ProductName) {
        if (lang == 1) {
          productName = ProductName.split("￥$")[2];
        } else if (lang == 2) {
          productName = ProductName.split("￥$")[0];
        } else {
          productName = ProductName.split("￥$")[1];
        }
      }
      return productName;
    },
    toFix(v) {
      if (v) {
        return Number(v).toFixed(2);
      }
      return v;
    },
  },
  methods: {
    //修改meta 标签
    editMeta() {
      let _this = this;
      if (this.ProductCataID) {
        this.$store
          .dispatch("GetMeta", {
            ProductCataID: _this.ProductCataID,
            LanguageType: this.lang
          })
          .then(res => {
            let viewport = document.querySelector("meta[name=keywords]");
            viewport.setAttribute("content", res.Data.KeyWords);
            let description = document.querySelector("meta[name=description]");
            description.setAttribute("content", res.Data.DeScription);
            document.title = res.Data.Title;
          });
      }
    },
    // 播放视频
    play() {
      let _this = this;
      this.showVideo = true;
      // this.autoplay = true
      this.timer = setTimeout(() => {
        _this.$refs.video.play();
      }, 200);
    },
    // 暂停视频
    cancel() {
      this.showVideo = false;
      // this.autoplay = false
      this.$refs.video.pause();
    },
    getDetail(id) {
      this.spinShow = true;
      this.$store
        .dispatch("GetDetailByProID", {
          ProductID: id,
          TempId: this.token ? "" : localStorage.getItem("TempId"),
          devtype: 1,
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : "",
        })
        .then(({ Data }) => {
          this.productDetail = Data.info;
          this.tjlist = Data.tjList;
          this.goodsNum = Data.info.ProductCartNum;
          this.piclist = Data.info.Pic.split(",");
          if (Data.info.LargePic) {
            this.picLargelist = Data.info.LargePic.split(",");
          } else {
            this.picLargelist = Data.info.Pic.split(",");
          }
          this.isCollect = Data.isShouCan;
          this.spinShow = false;
          this.videoSrc = Data.info.provideo;
        });
        setTimeout(()=>{
          this.Active_Height=  this.$refs.ref1.offsetHeight;
          // 1186图片的高度
          this.imageNum=Math.ceil(this.Active_Height/1376);
        },1000)
    },
    //获取指定品类的所有上级类别 （包含当前品类）适用于 面包屑 场景 如 商品详情页面
    GetUpCata() {
      this.$store
        .dispatch("GetUpCata", {
          CataID: this.ProductCataID,
        })
        .then((res) => {
          if (res.Code == 200) {
            this.catas = res.Data;
          }
        });
    },
    //设置商品数量
    changeCartNum(operate) {
      if (operate == "min") {
        if (this.goodsNum == 1) return;
        this.goodsNum--;
      }

      if (operate == "plu") {
        if (this.goodsNum == 50) return;
        this.goodsNum++;
      }
    },
    //输入商品数量时 商品数量不能大于50
    inputGoodsNum() {
      if (this.goodsNum >= 50) {
        alert("您输入的数量过大");
        this.goodsNum = 50;
      }
    },

    up() {
      this.activeIndex += 1;
      this.move();
    },
    down() {
      if (this.activeIndex == 0) {
        return;
      }
      this.activeIndex -= 1;
      this.move();
    },
    move() {
      if (this.piclist.length <= 4) {
        return;
      }
      if (
        this.$refs.ulRef.offsetTop + 83 * this.len <
        -this.$refs.ulRef.offsetHeight / 2
      ) {
        this.$refs.ulRef.style.top = "0px";
        this.activeIndex = 0;
      }
      this.$refs.ulRef.style.top = this.iSpeed * 83 * this.activeIndex + "px";
    },
    joinPic(num) {
      this.$nextTick(() => {
        if (this.piclist.length > num) {
          this.len = this.piclist.length - 1 - num;
          this.piclist = this.piclist.concat(this.piclist);
        }
      });
    },
    selectPic(idx) {
      if (this.showVideo) {
        this.showVideo = false;
        this.cancel();
      }
      this.curThumbIndex = idx;
    },
    // 查询是否有多规格信息
    ShowPopup(item){
          const {CityID} = JSON.parse(localStorage.getItem("cityInfo"))
					this.$store.dispatch("ShowBindingProductList",{
						ProductID: item.ProductID,
						CityID,
						isSign:true
					}).then(res=>{
            if(res.Data.BindingProductList.length > 0 && res.Data.BindingProductList.length < 3 ){
              let arr = res.Data.BindingProductList;
              arr.unshift(res.Data.MasterProduct)
							this.$ProductSpec(arr)
						} else if(res.Data.BindingProductList.length >= 3 ){
              let arr = res.Data.BindingProductList;
							arr.splice(3)
              arr.unshift(res.Data.MasterProduct)
              this.$ProductSpec(arr)
            } else{
              this.addCart(item.ProductID)
						}
					})
		},
    addCart(id) {
      const _this = this;
      let TempId = "";
      if (this.token) {
        TempId = "";
      } else {
        TempId = localStorage.getItem("TempId");
      }
      _this.$store
        .dispatch("AddToCart", {
          productid: id,
          num: this.goodsNum,
          cartKind: 1,
          TempId,
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : "",
        })
        .then((res) => {
          if (res.Code == 200) {
            // if (res.Data.Tip == 0) {
            // } else if (res.Data.Tip == 106) {
            //   alert("" + this.$t("hint.outBuyNum"));
            // } else if (res.Data.Tip == 107) {
            //   alert("" + this.$t("hint.chaochu"));
            // } else {
            //   {
            //     alert("" + this.$t("hint.buhuo"));
            //   }
            // }
            switch (res.Data.Tip) {
              case 104:
                // 超出限购数量
                alert("" + this.$t("addcartMessage.mes4"));
                break;
              case 105:
                // 此商品购买数量不可超过50
                alert("" + this.$t("addcartMessage.mes7"));
                break;
              case 106:
                // 购买数量不能超过促销活动单笔限购数量
                alert("" + this.$t("hint.outBuyNum"));
                break;
              case 107:
                // 购买数量不能超过促销活动单笔限购数量
                alert("" + this.$t("hint.outBuyNum"));
                break;
              case 108:
                // 超出限购数量
                alert("" + this.$t("addcartMessage.mes4"));
                break;
              case 210:
                // 库存不足!
                alert("" + this.$t("productList.inventory"));
                break;
              case 211:
                // 商品不存在
                alert("" + this.$t("addcartMessage.mes8"));
                break;
              case 212:
                // 已过期
                alert("" + this.$t("addcartMessage.mes1"));
                break;
              case 213:
                // 重复参加该促销活动！
                alert("" + this.$t("addcartMessage.mes9"));
                break;
              case 214:
                // 不符合条件！
                alert("" + this.$t("addcartMessage.mes10"));
                break;
              case 215:
                // 已下架
                alert("" + this.$t("addcartMessage.mes11"));
                break;
              case 216:
                // 此商品购买数量不可超过50
                alert("" + this.$t("addcartMessage.mes7"));
                break;
              case 217:
                // 你还未登录
                alert("" + this.$t("headerNav.hint_noLogin"));
                this.$router.replace({
                  path: "/login",
                  query: {
                    redirectUrl: this.$route.fullPath,
                  },
                });
                break;
              case 218:
                // 超出限购数量
                alert("" + this.$t("addcartMessage.mes4"));
                break;
              case 220:
                // 未达到会员等级
                alert("" + this.$t("CouponVersion.CouponVersion37"));
                break;
              case 222:
                // 购物车选择赠品
                break;
              case 223:
                //赠品加入购物车不满足条件
                alert("" + this.$t("CouponVersion.CouponVersion32"));
                break;
              case 224:
                //因为优惠券到期导致优惠券下的商品无法加入购物车
                alert("" + this.$t("CouponVersion.CouponVersion33"));
                break;
              case 225:
                //活动限于第xx单用户
                alert("" + this.$t("CouponVersion.CouponVersion38") + " " + res.Data.ordernum + "" + this.$t("CouponVersion.CouponVersion39"));
                break;
            }
            _this.GetCartPros(res.Data.Tip);
          }
        });
    },
    // 获取购物车商品
    GetCartPros(Tip) {
      const _this = this;
      let TempId = "";
      if (this.token) {
        TempId = "";
      } else {
        TempId = localStorage.getItem("TempId");
      }
      _this.$store
        .dispatch("GetCartPros", {
          TempId,
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : "",
        })
        .then(({ Data }) => {
          this.$store.commit("setShopCar", Data);
          if(Tip==0){
          this.$store.commit("needShowCartToSeconds", true);
          }else{
          this.$store.commit("needShowCartToSeconds", false);
          }
        });
    },
    // 设置到货提醒
    arrivalRemind(id) {
      const _this = this;
      _this.$store
        .dispatch("SetArrivalNotice", {
          productid: id,
          Token: localStorage.getItem("Token")
            ? localStorage.getItem("Token")
            : "",
        })
        .then((res) => {
          if (res.Code == 200) {
            alert("" + this.$t("hint.hint_remind"));
          }
        });
    },
    // 收藏
    collect(id) {
      const _this = this;
      if (_this.token) {
        _this.$store
          .dispatch("SumimtShouCang", {
            productid: id,
            Token: localStorage.getItem("Token")
              ? localStorage.getItem("Token")
              : "",
          })
          .then((res) => {
            if (res.Code == 200) {
              this.isCollect = true;
              // alert("" + this.$t("hint.hint_like"));
            }
          });
      } else {
        alert("" + this.$t("headerNav.hint_noLogin"));
        _this.$router.replace({
          path: "/login",
          query: {
            redirectUrl: this.$route.fullPath,
          },
        });
      }
    },
    delCollect(id) {
      if (this.token) {
        this.$store
          .dispatch("DelShouCang", {
            Id: id,
            Token: localStorage.getItem("Token")
              ? localStorage.getItem("Token")
              : "",
          })
          .then((res) => {
            if (res.Code == 200) {
              this.isCollect = false;
              // alert("" + this.$t("hint.hint_quxiao"));
            }
          });
      } else {
        alert("" + this.$t("headerNav.hint_noLogin"));
        this.$router.replace({
          path: "/login",
          query: {
            redirectUrl: this.$route.fullPath,
          },
        });
      }
    },
    isShowDiscount(discount) {
      let discounts = [
        5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90,
        95, 100,
      ];
      if (discounts.indexOf(discount) >= 0) {
        return true;
      }
      return false;
    },
  },
  destroyed() {
    clearTimeout(this.timer);
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/products/productDetail.vue